import type { IProjectsGateway } from "../ports/IProjectsGateway";
import type { ProjectDTO } from "../dtos/ProjectDTO";

export class GetAllProjectsAdminUseCase {
  constructor(private readonly projectsGateway: IProjectsGateway) {}

  async execute(): Promise<ProjectDTO[]> {
    return this.projectsGateway.getAllProjectsAdmin();
  }
}
